<template>
	<div>
		<div @click="onModalOpened" :class="{'registration-opener': true, 'has-registrations': nonzeroRegistrations}">
			<p v-if="nonzeroRegistrations">
				See {{ tournament.numRegistrations }} {{ registrationTypeName }} that {{ haveHas }} signed up already.
			</p>
			<p v-else>No teams have signed up yet, be the first!</p>
		</div>
		<b-modal @close="onModalClosed" :active="modalOpened" :width="640" scroll="keep">
			<div class="modal-card" style="width: auto">
				<header class="modal-card-head">
					<p class="modal-card-title">
						{{ tournament.name }} Registrations
					</p>
				</header>
				<section class="modal-card-body">
					<registrations-runner v-if="modalOpened" :tournament="tournament" v-slot="{registrations, registrationType}" class="card-content">
						<tournament-individual-list :individuals="registrations" v-if="registrationType == 'individual'" />
						<tournament-team-list :teams="registrations" v-else-if="registrationType == 'team'" />
					</registrations-runner>
				</section>
				<footer class="modal-card-foot">
					<button class="button" type="button" @click="onModalClosed">Close</button>
				</footer>
			</div>
		</b-modal>
	</div>
</template>

<script>
	import RegistrationsRunner from '@/components/RegistrationsRunner.vue';
	import TournamentIndividualList from '@/components/TournamentIndividualList.vue';
	import TournamentTeamList from '@/components/TournamentTeamList.vue';

	export default {
		name: "RegistrationsList",
		props: {
			tournament: {
				type: Object,
				required: true
			},
		},
		components: {
			RegistrationsRunner,
			TournamentIndividualList,
			TournamentTeamList
		},
		data() {
			return {
        modalOpened: false,
			}
		},
		computed: {
			registrationTypeName() {
				let name = this.tournament.individualRegistration ? "individual" : "team";
				return `${name}${this.tournament.numRegistrations == 1 ? '' : 's'}`;
			},
			haveHas() {
				return this.tournament.numRegistrations == 1 ? 'has' : 'have';
			},
			nonzeroRegistrations: vm => vm.tournament.numRegistrations > 0
		},
		methods: {
      onModalClosed() {
        this.modalOpened = false;
			},
			onModalOpened() {
				if (this.nonzeroRegistrations) this.modalOpened = true;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.registration-opener {

		&.has-registrations {
			cursor: pointer;
			text-decoration: underline;
			text-decoration-color: hsl(204, 86%, 53%);
			transition: color;
			&:hover {
				color: hsl(204, 86%, 53%);
			}
		}
	}
	.modal-card-foot {
		flex-direction: row-reverse;
	}
</style>